import { useState } from "react";

import { Badge2 } from "@/ui2/atoms/Badge";
import { Button2 } from "@/ui2/atoms/Button";
import EyeIcon from "@/assets/images/icons2/icon--eye.svg?component";
import type { UUID } from "@/core/types";

import { IdentityDocumentPreviewModal } from "./IdentityDocumentPreviewModal";

type IdentityDocumentPreviewButtonProps = {
  entityId?: UUID;
  isDisabled?: boolean;
};

export function IdentityDocumentPreviewButton({
  entityId,
  isDisabled,
}: IdentityDocumentPreviewButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="tw:flex tw:items-center tw:gap-2">
        <Badge2 appearance="outline" className="tw:h-auto" size="sm" variant="success">
          Uploaded
        </Badge2>
        <Button2
          classNameChildren="tw:flex tw:gap-1"
          icon={<EyeIcon />}
          isDisabled={isDisabled}
          onPress={() => setIsModalOpen(true)}
          size="sm"
          variant="text"
        >
          View
        </Button2>
      </div>

      <IdentityDocumentPreviewModal
        entityId={entityId}
        isModalOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </>
  );
}
